import React, { useState } from "react";

// reactstrap components
import { Row, Col } from "reactstrap";
import Layout from "../../components/Layout/Layout";
import styles from "./PickupLocation.module.css";
import { Link } from "react-router-dom";
import Geocode from "react-geocode";
import { useDispatch, useSelector } from "react-redux";
import {
    savePickupLocation,
} from "../../redux/actions/orderActions";
import Map from './../../components/Map/index'

const PickupLocation = React.forwardRef(() => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [pickupNumber, setPickupNumber] = useState("");
    const [pickupName, setPickupName] = useState("");
    const [landmark, setLandmark] = useState("");
    const today = new Date();
    const date =
        today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    const [locationState, setLocationState] = React.useState({
        meetingPoint: "",
        address: '',
        city: '',
        area: '',
        state: '',
        country: '',
        mapPosition: {
            lat: 0,
            lng: 0
        },
        markerPosition: {
            lat: 0,
            lng: 0
        },
    });
    const pickLocationObj = useSelector(state => state?.savePickup?.pickupInfo ? state?.savePickup?.pickupInfo : {})

    const savePickup = () => {
        const pickupInfo = {
            pickupLocation: landmark,
            pickupNumber: pickupNumber,
            pickupName: pickupName,
            Landmark: landmark,
            time: time,
            date: date,
            address: {
                address: landmark,
                coordinates: {
                    lat: locationState?.mapPosition?.lat,
                    long: locationState?.mapPosition?.lng,
                },
            },
        };
        dispatch(savePickupLocation(pickupInfo));
    };

    return (
        <>
            <Layout title="Pickup Location" route={"/"}>

                <div className="content map" style={{ marginTop: '101px' }}>
                    <Row>
                        <Map
                            setState={setLocationState}
                            state={locationState}
                            setLandmark={setLandmark}
                            setNumber={setPickupNumber}
                            setName={setPickupName}
                            fillUpData={{
                                ...pickLocationObj,
                                userName: pickLocationObj?.pickupName,
                                number: pickLocationObj?.pickupNumber,

                            }}
                            style={{
                                boxSizing: 'border-box',
                                border: '2px solid #ccc',
                                borderRadius: '4px',
                                fontSize: '16px',
                                backgroundColor: 'white',
                                backgroundImage: `url('search.svg')`,
                                backgroundPosition: '6px 8px',
                                backgroundSize: '24px',
                                backgroundRepeat: 'no-repeat',
                                padding: '12px 20px 12px 40px',
                                width: '50%',
                                height: '42px',
                                position: 'absolute',
                                top: '110px',
                                left: '60px',
                            }}
                        />
                        <Col>
                            {true ? (
                                <div className={styles.detailContainer}>
                                    <div className={styles.input_2}>
                                        <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                                        <input
                                            type="text"
                                            value={landmark}
                                            onChange={(e) => setLandmark(e.target.value)}
                                            name="place"
                                            placeholder="Enter Landmark"
                                        />
                                    </div>

                                    <div className={styles.input_2}>
                                        <i className={styles.icon + " fas fa-user"}></i>
                                        <input
                                            type="text"
                                            value={pickupName}
                                            onChange={(e) => setPickupName(e.target.value)}
                                            name="location"
                                            placeholder="Name of person"
                                        />
                                    </div>
                                    <div className={styles.input_2}>
                                        <i className={styles.icon + " fas fa-phone"}></i>
                                        <input
                                            type="text"
                                            value={pickupNumber}
                                            onChange={(e) => setPickupNumber(e.target.value)}
                                            name="location"
                                            placeholder="Contact Number"
                                        />
                                    </div>
                                    <Link to="/drop-location">
                                        <button onClick={savePickup}>
                                            Continue{" "}
                                            <i className={styles.icon + " fas fa-long-arrow-alt-down"}></i>
                                        </button>
                                    </Link>
                                </div>
                            ) : <button>Continue</button>}
                        </Col>
                    </Row>
                </div>

            </Layout>
        </>
    );
})

export default PickupLocation
